export default {
    "entityName": "sitecode",
    "title": "Providers code",
    id: ['site_id', 'provider_id', 'protocol_id'],
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "site_id",
        "descending": true
    },
    "fields": [
        {
            "value": "provider_id",
            reference: 'drug',
            id: 'provider_id',
            "text": "Provider",
            "type": "autocomplete",
            filter: item => ({ protocol_id: item.protocol_id }),
            "title": "provider.name",
            subtitle: 'provider.city',
            table: {
                sortable: true
            },
            validators: ['required'],
        },
        {
            "value": "code",
            "text": "Code",
            table: {
                sortable: true,
                filter: true,
            },
            "subtitle": "email",
            readonly: item => !item.provider_id,
            validators: ['required'],
        },
    ],
    "actions": [
        "upsert", "remove"
    ]
}